import { render } from "./IndexSider.vue?vue&type=template&id=3f728502"
import script from "./IndexSider.vue?vue&type=script&lang=js"
export * from "./IndexSider.vue?vue&type=script&lang=js"
script.render = render

export default script